/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { Redirect, useHistory } from 'react-router-dom';
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { useGiftTableInfo, useIsMobile } from 'hooks';
import { useDispatch } from 'store';
import { setLoginRedirectSSO } from 'util/navigation';
import { AGENT_STAFF, CURRENT_GIFT_TABLE, SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import GiftsHeader from 'components/gifts-table/GiftsHeader';
import { removeGiftTable, resetGiftTable } from 'store/actions/giftTable';
import { QuestionHome } from 'pages/Home/HomeFAQ/QuestionHome/questionhome';
import { PROJECT_BASENAME } from 'constants/env';

import Slider from 'react-slick';
import Styles from './styles.module.sass'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const CintilloMonederoSears = () => (
    <section className={Styles?.headBandNew}>
      <a href="https://www.sears.com.mx/c/historias/" target="_blank" className={Styles?.headBandLink} rel="noreferrer">
        <span className={Styles?.contentBandNew}>
            <span className={Styles?.iconHeart} />
          <span className={Styles?.firstText}>Gana Hasta $150,000 pesos en monedero...</span>
          <span className={Styles?.lastText}>¡solo comparte tu historia de amor!</span>
          <span className={Styles?.buttonText}>Participa ahora</span>
        </span>
      </a>
    </section>
)

const HeroSection = ({ isLoggedIn }) => {
    const date = new Date()
    const homeBackground = `https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/mesa-original-v1.png?ttl=${date.getFullYear()}${date.getMonth()}${date.getDate()}`

    return(
        <section
            className={Styles?.NewSectionTitle}
            style={{ backgroundImage: `url(${homeBackground})` }}
        >
          <div className={Styles?.contBtnsMesa}>
            <div className={Styles?.contLogo}>
                <span className={Styles?.iconMesaRegalos} />
            </div>
            <a className={Styles?.linkButton} href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
              <div className={Styles?.primaryButton}>
                Crea tu mesa
              </div>
            </a>
            <a className={Styles?.linkButton} href='/Mesa-de-Regalos/buscar-evento'>
              <div className={Styles?.primaryButton}>
                Buscar evento
              </div>
            </a>

            <a className={Styles?.linkButton} href={setLoginRedirectSSO('my-table', true, isLoggedIn, true)}>
              <div className={`${Styles?.primaryButton} ${Styles?.underline}`}>
                <span className={Styles?.linkIrMesa}>Entrar a mi mesa</span>
              </div>
            </a>

          </div>
        </section>
    )
}

const ModuleBeneficios = (props) => {
    const {
        contBeneficio,
        eventos = [],
        titles,
        claseModule
    } = props

    const history = useHistory();

    const createEvent = (url) => {
        history.push(url);
    }

    return(
        <div className={Styles?.contentBeneficts}>
            <img className={Styles?.imageBen} src={contBeneficio?.img} alt={contBeneficio?.title} />
            <p className={Styles?.h2}>{titles}</p>
            <p className={Styles?.h3}>{contBeneficio?.subTitle}</p>

            <ul className={`${Styles?.benefictsIcons} ${Styles?.[claseModule]}`}>
                {eventos.map((evento, index) => (
                    <li key={index}>
                        <span onClick={() => createEvent(evento.url)} className={Styles?.iconEvents}>
                           <img className={Styles?.iconEvents} src={evento?.ico} alt={evento?.title} />
                            <p>Crear mesa</p>
                        </span>
                        {evento?.title}
                    </li>
                ))}
            </ul>

            <div className={Styles?.contentBeneficiosCard}>
                <p className={Styles?.titlePoints}>Beneficios</p>
                <ul className={Styles?.benefictsPoints}>
                    {contBeneficio?.beneficios.map((beneficio, index) => (
                        <li key={index} dangerouslySetInnerHTML={{__html: beneficio}} />
                    ))}
                </ul>

                <ul className={Styles?.benefictsPeros}>
                    {contBeneficio?.peros.map((pero, index) => (
                        <li key={index}>{pero}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

const ModuleSliderInf = (props) => {

    const { imagenesSlider = [] } = props
    const { isMobile } = useIsMobile()

    const settingsInf = {
        dots: false,
        autoplay: true,
        infinite: true,
        dotsClass: Styles?.dotsSliders,
        className: Styles?.slideSlidersInf,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        speed: 700,
        mode: 'fade',
        captions: true,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    autoplay: true,
                    infinite: true,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    return(
        <div className={Styles?.contSilder}>
            <Slider {...settingsInf}>
                {imagenesSlider.map(({ img_web, img_app, name, url_web , target},index) => {
                    const imageFinal = isMobile === 'movil' ? img_app : img_web;
                    return(
                        <a href={url_web || ''} title={name} key={index} className={Styles?.cardSliderBeneficios} target={target}>
                            <img className={Styles?.[`${isMobile}_slider`]} loading="lazy" src={imageFinal} alt={name} width="260" height="485" importance="low" />
                            <div className={`${Styles?.buttonVerOferta} ${Styles?.[isMobile]}`}>Ver oferta</div>
                        </a>
                    )
                })}
            </Slider>
        </div>
    )
} 

const SectionEvents = (props) => {
    const { 
        respEvents 
    } = props

    const celebracion = {
        img: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/celebracion.png',
        subTitle: 'Selecciona una opción:',
        beneficios: [
            'Recibe tus regalos en casa con <strong>envío GRATIS</strong> o recibe un monedero SEARS.',
            'Los invitados podrán comprar los regalos en tienda o en linea.',
            'Recibe hasta el <strong>5% ó 10% de bonificación</strong> sobre tus compras.*',
            'Todos los eventos te dan <strong>regalos de bienvenida.**</strong>',
            'Notificaciones en tiempo real.',
            '<strong>Personaliza tu mesa</strong> con fotografías, mensajes para tus invitados y notas de agradecimiento.',
            'Servicio sin costo.',
            'Al cerrar tu Mesa de Regalos recibirás un obsequio. ***',
        ],
        peros: [
            '    * Consulta marcas y departamentos participantes con tu asesora en tienda.',
            '  ** Con un mínimo de compra de $500.00 MXN.',
            '*** Aplica para compras mínimas de $5,000.00 MXN.'
        ]
    }

    const todaOcacion = {
        img: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/toda_ocacion.png',
        subTitle: 'Selecciona una opción:',
        beneficios: [
            'Recibe tus regalos en casa con <strong>envío GRATIS</strong> o recibe un monedero SEARS.',
            'Los invitados podrán comprar los regalos en tienda o en linea.',
            'Notificaciones en tiempo real.',
            '<strong>Personaliza tu mesa</strong> con fotografías, mensajes para tus invitados y notas de agradecimiento.',
            'Servicio sin costo.',
            'Al cerrar tu Mesa de Regalos recibirás un obsequio. *',
        ],
        peros: [
            '* Aplica para compras mínimas de $5,000.00 MXN'
        ]
    }
    
    return(
        <section>
            <div className={Styles?.moduleTitleBeneficts}>
                <h1>Festeja cualquier evento especial, tu graduación, nuevo hogar, bautizos... en fin.</h1>
                <p>¡Tenemos la mesa digital perfecta para que tu evento sea inolvidable!</p>
            </div>

            <div className={`${Styles?.contSectionBeneficios}`}>
                <ModuleBeneficios 
                    contBeneficio={celebracion} 
                    titles={respEvents?.celebracionTitle} 
                    eventos={respEvents?.celebracionEvents}
                    claseModule="celebracion"
                />
                <ModuleBeneficios 
                    contBeneficio={todaOcacion} 
                    titles={respEvents?.todaOcacionTitle} 
                    eventos={respEvents?.todaOcacionEvents} 
                    claseModule="todaOcacion"
                />
            </div>

        </section>
    )
}

const SectionSteps = () => {
    const steps = {
        title: '¡Así de fácil es crear una Mesa de Regalos!',
        pasos: [
            {ico: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/step_1.svg', title: 'Elige un tipo de evento'},
            {ico: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/step_2.svg', title: 'Elige un plan'},
            {ico: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/step_3.svg', title: 'Selecciona tus regalos'},
            {ico: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/step_4.svg', title: 'Comparte tu mesa con tus invitados'},
            {ico: 'https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/step_5.svg', title: 'Cierre de evento'}
        ]
    }

    return(
        <section>
            <div className={Styles?.contSteps}>
                <p>{steps?.title}</p>
                <div className={Styles?.contStepsList}>
                    <ul className={Styles?.stepsList}>
                        {steps?.pasos.map((paso, index) => (
                            <li key={`step-${index}`}>
                                <div>
                                    <img src={paso?.ico} alt={paso?.title} />
                                    <div className={Styles?.textSteps}>
                                        {index+1}.
                                        <span>{paso?.title}</span>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
}

const SectionSliderSup = (props) => {
    const { 
        respSlider = [] 
    } = props

    const { isMobile } = useIsMobile()

    const settings = {
        dots: true,
        autoplay: true,
        infinite: true,
        dotsClass: Styles?.dotsSliders,
        className: Styles?.slideSliders,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    autoplay: true,
                    infinite: true,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    return(
        <section>
            <div className={Styles?.contSlider}>
                <Slider {...settings}>
                    {
                        respSlider.map(({img_web, img_app, name, url_web, target}, index) => {
                            const imageFinal = isMobile === 'movil' ? img_app : img_web;
                            return(
                                <a href={url_web} title={name} target={target} key={index}>
                                    <img className={Styles?.[`${isMobile}_slider`]} src={imageFinal} alt={`Paso ${index}`} importance="low" loading="lazy" />
                                </a>
                            )
                        })
                    }
                </Slider>
            </div>
        </section>
    )
}

const SectionSliderInf = (props) => {
    const { 
        respSlider = [] 
    } = props

    return(
        <section>
           {respSlider
                ? <ModuleSliderInf imagenesSlider={respSlider} />
                : null
            }
        </section>
    )
}

const Home = () => {

    const [isLogged] = decodeStorage('session_token');
    const dispatch = useDispatch();
    
    const { hasGiftTableAndIsLogged } = useGiftTableInfo();
    const isLoggedIn = !!(isLogged && isLogged.length);
    localStorage.removeItem('giftTablesTotalbypass');

    useEffect(() => {
        if (!isLogged) {
          removeStorage(CURRENT_GIFT_TABLE);
          removeStorage(AGENT_STAFF);
          removeStorage(SEARS_PRODUCT);
          removeStorage(TOTAL_GIFT_TABLES);
          dispatch(removeGiftTable());
          dispatch(resetGiftTable());
        }
        // To Add Product From Sears
        const url = new URL(window.location);
        if(url.search.includes(SEARS_PRODUCT)) {
          //  console.log('A qui se agrega un regalo que viene desde el portal de Sears');
          const productUrl = url.search.replace(`?${SEARS_PRODUCT}=`, '');
          encodeStorage(SEARS_PRODUCT, productUrl);
          setTimeout(() => {
            window.location.href = `${PROJECT_BASENAME}my-table-bypass`;
          }, 3000);
        }
    }, [isLogged]);


    const [ response, setResponse ] = useState()
    const [ responseEvent, setResponseEvent ] = useState()
    const [ respSlider, setRespSlider ] = useState()
    const [ respEvents, setRespEvents ] = useState()


    const sanitizeEvents = (events) => {
        const newEvents = events.map(event => ({
            ico: event?.img, 
            title: event?.name,
            id: event?.id,
            url: '/crear-mesa/'
        }))
        return newEvents
    }

    const getBanners = async () => {
        try {
            const resp1 = await fetch('https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/carrusel-promos/promociones_mr.json');
            const data = await resp1.json();
            setResponse(data)
        } catch (error) {
            console.error('Error fetching getBanners data:', error);
        }
    }
    
    const getEventTypes = async () => {
        try {
            const resp2 = await fetch('https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/nuevaMesa/tipos_mesa.json');
            const data = await resp2.json();
            setResponseEvent(data)
        } catch (error) {
            console.error('Error fetching getEventTypes data:', error);
        }
    }

    useEffect(()=>{
        getBanners()
        getEventTypes()
    },[])

    useEffect(()=>{
        if(response){
            if(response?.sections?.length > 0){
                const participacion = response?.sections.find(section => section?.section_name === 'participacion_blog');
                const promociones = response?.sections.find(section => section?.section_name === 'promociones_mr');
                setRespSlider({
                    itemPaticipacion: participacion?.items,
                    itemPromociones: promociones?.items
                })
            }
        }
    },[response])

    useEffect(()=>{
        if(responseEvent){
            if(responseEvent?.sections?.length > 0){
                const celebracionEvents = responseEvent?.sections.find(section => section?.section_name === 'Celebración');
                const todaOcacionEvents = responseEvent?.sections.find(section => section?.section_name === 'Toda Ocasión');
                setRespEvents({
                    celebracionTitle: celebracionEvents?.section_name,
                    celebracionEvents: sanitizeEvents(celebracionEvents?.items),
                    todaOcacionTitle: todaOcacionEvents?.section_name,
                    todaOcacionEvents: sanitizeEvents(todaOcacionEvents?.items)
                })
            }
        }
    },[responseEvent])

    if (hasGiftTableAndIsLogged) {
        return <Redirect to="/my-table" />;
    }

    return(
        <>
            <Header type="complete" />
            <main className="gifts-root">
                <div className={Styles?.contHeaderHidden}>
                    <GiftsHeader />
                </div>

                <HeroSection isLoggedIn={isLoggedIn} />
                
                <CintilloMonederoSears />
                
                <SectionEvents respEvents={respEvents}  />

                <SectionSteps />

                <SectionSliderSup respSlider={respSlider?.itemPaticipacion} />

                <SectionSliderInf respSlider={respSlider?.itemPromociones} />

                <QuestionHome  />

            </main>
            <Footer type="complete" />
        </>
    )
}

export default Home;